<div class="graph-header">
    <span class="graph-heading">Worker Availability</span>
    <span class="graph-subtitle">
        Workers available over time for each run. Shaded bands mark each run; dotted lines mark when an iteration was
        dumped.
        Scroll or drag the slider to zoom, and click a run in the legend to hide it.
    </span>
</div>

<nz-spin [nzSpinning]="workerAvailabilityResource.isLoading()">

    @if (workerAvailabilityResource.hasValue()){
    <div class="chart-container">
        <div echarts [options]="chartOption()" class="echarts-graph"></div>
    </div>
    }@else if (workerAvailabilityResource.error()) {
    <nz-alert nzType="error" [nzMessage]="`Failed to load availability data: ${errorMessage()}`" />
    }

</nz-spin>